import axios, { AxiosInstance } from 'axios';
import ApiError from '@/api/misc/ApiError';
import { Vue } from 'vue-property-decorator';
import ProxyChecker from '@/misc/ProxyChecker';
import store from './../../store/index';

/**
 * Base repository for auth repositories
 */
export default class AuthBaseRepository {

    protected axiosClient!: AxiosInstance;
    protected baseURL: string = ProxyChecker.getBaseURL() + process.env.VUE_APP_BASE_URL_EXTENSION!;
    protected endpointDefault: string = process.env.VUE_APP_ENDPOINT_DEFAULT!;
    protected endpointLocalization: string = process.env.VUE_APP_ENDPOINT_LOCALIZATION!;
    protected apiVersion: string = process.env.VUE_APP_API_VERSION!;
    protected clientType: string = process.env.VUE_APP_CLIENT_TYPE!;

    constructor() {
        this.createHttpClient();
        this.setRequestInterceptors();
        this.setResponseInterceptors();
        console.info('using host: ', this.baseURL);
    }

    private createHttpClient() {
        this.axiosClient = axios.create({
            baseURL: this.baseURL,
            withCredentials: true, // necessary to send php sessionId for client identification
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    /**
     * Add Bridge values if necessary
     * This is a special parameter which allows the communication in an iframe on safari
     * @private
     */
    private setRequestInterceptors() {
        this.axiosClient.interceptors.request.use((config) => {
            // if bridge value is available - use it!
            if (store.getters['auth/bridge']) {
                config.headers = { Bridge: store.getters['auth/bridge'] };
            }
            return config;
        });
    }

    /**
     * Intercept response. Normalizes the response and handles certain error cases
     */
    private setResponseInterceptors() {
        // normalize response
        this.axiosClient.interceptors.response.use(
            (response) => {
                // check for error
                // shm api returns no http error codes when a response has an error...
                // if the response has a code, an error occured
                // The localization endpoint has a special treatment. The codes which are returned there are no errors...
                // code 105 is the success code for an logout request
                if (response.config.url !== this.endpointLocalization && response.data.response?.code !== 105) {
                    if (response.data.response?.code) {
                        throw new ApiError(response.data.response.code, response.data.response.message, response.data.response.data);
                    }
                }
                return response;
            },
            (error) => {
                console.log(error);
                if (error.response) {
                    console.log(error, error.response);
                    // has response -> server error
                    Vue.notifyErrorSimplified('GENERAL.NOTIFICATIONS.SERVER_ERROR');
                    return new Promise(() => {
                        // cancels process of the interceptor chain
                    });
                } else {
                    // no response -> network error
                    Vue.notifyErrorSimplified('GENERAL.NOTIFICATIONS.NETWORK_ERROR');
                    return new Promise(() => {
                        // cancels process of the interceptor chain
                    });
                }
            });
    }
}
